import * as LucideIcons from 'lucide-react';

type IconProps = {
  name: string;
  size?: number;
  color?: string;
  className?: string;
};

export const AVAILABLE_ICONS = [
  'Fuel',
  'Zap',
  'Wrench',
  'Shield',
  'Info',
  'Search',
  'Car',
  'Gauge',
  'Droplet',
  'Thermometer',
  'Sparkles',
  'FileText',
  'CircleDollarSign',
  'Hammer',
  'Cog',
  'AlertTriangle',
  'CheckCircle',
  'Clock',
  'Calendar',
  'TrendingUp',
  'Package',
  'ShoppingCart',
  'CreditCard',
  'Wallet',
  'Tag',
  'Star',
  'Heart',
  'MapPin',
  'Circle',
  'Receipt',
  'Banknote',
  'Settings',
  'Tool',
  'Scissors',
  'Drill',
  'Paintbrush',
  'Brush',
  'Spray',
  'Wind',
  'Flame',
  'Snowflake',
  'Sun',
  'Moon',
  'Cloud',
  'Umbrella',
  'Truck',
  'Bus',
  'Bike',
  'Plane',
  'Ship',
  'Train',
  'Anchor',
  'Battery',
  'BatteryCharging',
  'Plug',
  'Radio',
  'Wifi',
  'Bluetooth',
  'Signal',
  'Volume2',
  'Bell',
  'Key',
  'Lock',
  'Unlock',
  'Eye',
  'Camera',
  'Video',
  'Image',
  'Music',
  'Disc',
  'Headphones',
  'Phone',
  'MessageCircle',
  'Mail',
  'Send',
  'Inbox',
  'Archive',
  'Bookmark',
  'Flag',
  'Award',
  'Trophy',
  'Target',
  'Gift',
  'ShoppingBag',
  'Coffee',
  'Wine',
  'Pizza',
  'Home',
  'Building',
  'Factory',
  'Store',
  'School',
  'Hospital',
  'TreePine',
  'Leaf',
  'Flower',
  'Apple',
  'Beaker',
  'Clipboard',
  'Briefcase',
  'Backpack',
  'Glasses',
  'Watch',
  'Shirt',
  'Printer',
  'Monitor',
  'Laptop',
  'Smartphone',
  'Tablet',
  'HardDrive',
  'Database',
  'Server',
  'Lightbulb',
  'Flashlight',
  'Compass',
  'Navigation',
  'Map',
  'Rocket',
  'Gem',
  'Crown',
  'Puzzle',
  'Gamepad2',
  'Dumbbell',
  'Activity',
  'BarChart',
  'PieChart',
  'Layers',
  'Box',
  'Boxes',
  'Container',
  'Trash2',
  'Recycle',
  'Download',
  'Upload',
  'RefreshCw',
  'RotateCw',
  'Share2',
  'Copy',
  'Cut',
  'Paperclip',
];

// Create a comprehensive case-insensitive map of all allowed Lucide icons
const lucideIconMap = AVAILABLE_ICONS.reduce((acc, key) => {
  acc[key.toLowerCase()] = key;
  return acc;
}, {} as Record<string, string>);

function normalizeIconName(name: string): string {
  if (!name) return 'Circle';
  const lowerName = name.toLowerCase().replace(/[^a-z0-9]/g, '');

  // Try dynamic map first
  if (lucideIconMap[lowerName]) {
    return lucideIconMap[lowerName];
  }

  // Fallback map for specific common aliases
  const aliases: Record<string, string> = {
    'gas': 'Fuel',
    'petrol': 'Fuel',
    'repairs': 'Wrench',
    'repair': 'Wrench',
    'carwash': 'Droplet',
    'car_wash': 'Droplet',
    'taxes': 'Receipt'
  };

  return aliases[lowerName] || 'Circle';
}

export function DynamicIcon({ name, size = 20, color, className }: IconProps) {
  const iconName = normalizeIconName(name);
  const IconComponent = (LucideIcons as any)[iconName] || LucideIcons.Circle;

  return <IconComponent size={size} color={color} className={className} />;
}

// PREVIOUS AVAILABLE_ICONS EXPORT WAS HERE

export const DEFAULT_COLORS = [
  '#F97316', // Orange
  '#3B82F6', // Blue
  '#10B981', // Green
  '#8B5CF6', // Purple (use sparingly)
  '#EF4444', // Red
  '#F59E0B', // Amber
  '#14B8A6', // Teal
  '#6366F1', // Indigo (use sparingly)
  '#EC4899', // Pink
  '#6B7280', // Gray
  '#84CC16', // Lime
  '#06B6D4', // Cyan
];

export function getIconComponent(name: string) {
  const iconName = normalizeIconName(name);
  return (LucideIcons as any)[iconName] || LucideIcons.Circle;
}
